import { useEffect } from 'react';

import { PageSize } from '~/core/shared/types';
import { useLayoutWrap } from '../useLayoutWrap';

/**
 * TODO: @haxxxton - Revisit this layout width override.
 *
 * This hook exists because some components (e.g. DealSummary) require a different
 * layout width than the step config specifies. DealSummary designs require 1200px+
 * but the need_documentation step has layoutWidth: 'lg' (1000px) which is correct
 * for the old view.
 *
 * We override at the component level because:
 * - LayoutWrapProvider sits high in the tree (Layout -> LayoutWrapProvider -> ... -> Component)
 * - The step's layoutWidth is applied by CustomStepRenderer before FeatureAwareComponent renders
 * - We can't have different layoutWidth per feature variant at the step config level
 *
 * Possible future solutions:
 * - FeatureAwareLayout component that sets width based on feature flag
 * - Extend FeatureAwareComponent with layoutWidth props
 * - Refactor layout system to allow component-level width overrides more cleanly
 *
 * The first two solutions seem bad, the layout system here likely needs a refactor
 */
export const useLayoutWidthOverride = (size: PageSize) => {
  const { setPageWidth } = useLayoutWrap();

  useEffect(() => {
    setPageWidth(size);
  }, [setPageWidth, size]);
};
